import { render, staticRenderFns } from "./previewImage.vue?vue&type=template&id=10ee6d56&scoped=true"
import script from "./previewImage.vue?vue&type=script&lang=js"
export * from "./previewImage.vue?vue&type=script&lang=js"
import style0 from "./previewImage.vue?vue&type=style&index=0&id=10ee6d56&prod&lang=scss&scoped=true"
import style1 from "./previewImage.vue?vue&type=style&index=1&id=10ee6d56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ee6d56",
  null
  
)

export default component.exports